var render = function render(){var _vm=this,_c=_vm._self._c;return _c('form',{attrs:{"disabled":_vm.disabled},on:{"submit":function($event){$event.preventDefault();return _vm.$emit('save')}}},[_c('vue-form-generator',{attrs:{"schema":_vm.schema,"model":_vm.model,"options":_vm.formOptions}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }